import {
  OnInit,
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AircraftEventSkeleton,
  AircraftEventAudit,
  AircraftEventBusinessPersonAudit,
  AircraftEventBusinessPersonSkeleton,
  ScheduledEventAudit
} from '../../+models/aircraft-event-audit.model';
import { AircraftEventBusinessPersonAuditListComponent } from '../aircraft-event-business-person-audit-list/aircraft-event-business-person-audit-list.component';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';

@Component({
  selector: 'sd-portal-aircraft-event-audit-list',
  templateUrl: './aircraft-event-audit-list.component.html',
  styleUrls: ['./aircraft-event-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AircraftEventAuditListComponent implements OnInit {
  @Input() aircraftEvent: AircraftEventSkeleton;

  @Input() loading: boolean;
  @Input() aircraftEventAudits: AircraftEventAudit[];
  @Input() scheduledEventAudits: ScheduledEventAudit[];
  @Output() loadAircraftEvent = new EventEmitter<number>();
  @Output() loadScheduledEvent = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();
  @Output() nextScheduledEventPage = new EventEmitter<number>();

  @Input() aircraftEventBusinessPersonLoading: boolean;
  @Input() aircraftEventBusinessPersonAudits: AircraftEventBusinessPersonAudit[];
  @Output() loadAircraftEventBusinessPerson = new EventEmitter<number>();
  @Output() loadNextAircraftEventBusinessPersonPage = new EventEmitter<number>();

  @Input() flightBusinessPersonTypes: RefTypeItem[];

  @ViewChildren(AircraftEventBusinessPersonAuditListComponent)
  aircraftEventBusinessPersonAuditLists: QueryList<AircraftEventBusinessPersonAuditListComponent>;

  get combinedAudits() {
    return this.aircraftEventAudits.concat(this.scheduledEventAudits);
  }

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadAircraftEvent.emit(this.aircraftEvent.aircraftEventId);
    this.loadScheduledEvent.emit(this.aircraftEvent.scheduledEventId);
  }

  onNextPage() {
    this.nextPage.emit(this.aircraftEvent.aircraftEventId);
    this.nextScheduledEventPage.emit(this.aircraftEvent.scheduledEventId);
  }

  aircraftEventBusinessPersonOpened(
    aircraftEventBusinessPerson: AircraftEventBusinessPersonSkeleton
  ) {
    setTimeout(() => {
      const match = this.aircraftEventBusinessPersonAuditLists.find(
        c =>
          c.aircraftEventBusinessPerson.aircraftEventBusinessPersonId ===
          aircraftEventBusinessPerson.aircraftEventBusinessPersonId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  getFlightBusinessPersonTypeName(
    flightBusinessPersonTypes: RefTypeItem[],
    flightBusinessPersonTypeId: number
  ) {
    const flightBusinessPersonType = flightBusinessPersonTypes.find(
      f => f.id === flightBusinessPersonTypeId
    );
    if (!flightBusinessPersonType) {
      return 'N/A';
    }
    return flightBusinessPersonType.name;
  }
}
